<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container cont-bdr mb-5">
          <!-- row starts -->
          <div class="row">
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-12 col-bdr-bottom">
              <p class="mt-2 mb-2">
                <span>
                  <strong>Report Title</strong>
                </span>
                <span class="float-right">
                  <strong>Event Code :</strong> T327
                </span>
              </p>
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-4 col-bdr-bottom">
              <img :src="basepath+'/unodc_logo.png'" class="mt-2 mb-2" alt="UNODC" width="200" />
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-4 col-bdr-bottom">
              <p class="mt-2 mb-2">
                <span>
                  <strong>Plot # 5-11, Diplomatic Enclave, G-5, P.O.BOX 1051, Islamabad 44000, Pakistan</strong>
                </span>
              </p>
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-4 col-bdr-bottom">
              <p class="mt-2 mb-2">
                <span>
                  <strong>Country Office Pakistan</strong>
                </span>
              </p>
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-12 col-bdr-bottom">
              <p class="mt-2 mb-2">
                <span>
                  <strong>Name of Event :</strong> Training on "Administrative Management, Managing Audit and Accounts"
                </span>
              </p>
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
          </div>
          <!-- row ends -->
        </div>

        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                    {
                      title: 'Dashboard',
                      url: 'dashboard'
                    },
                    {
                      title: 'Link 1',
                      url: 'link-1'
                    },
                    {
                      title: 'Link 2',
                      disabled: true
                    },
                    {
                      title: 'Active',
                      active: true
                    }
                  ]"
            ></vs-breadcrumb>
            <div class="heading mt-3">
              <h3 class="text-secondary">
                Training Program Report
                <span
                  class="btn btn-primary float-right btn-sm print-btn"
                  @click="printInvoice"
                >
                  <i class="material-icons">print</i> Print
                </span>
              </h3>
            </div>

            <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Event Information</h6>
              <div class="row col-sm-12">
                <label class="col-sm-2 font-weight-bold">Title:</label>
                <div
                  class="col-sm-10"
                >Swat Regional Police Training Centre 'eLearning' on Crime Prevention and Investigation from UNODC</div>
              </div>
              <div class="row col-sm-12">
                <label
                  class="col-sm-2 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >Start Date:</label>
                <p class="col-sm-2" style="padding:0px 0px 0px 15px">22-7-2019</p>

                <label class="col-sm-2 font-weight-bold p-0">End Date:</label>
                <p class="col-sm-2 p-0">27-7-2019</p>
                <label class="col-sm-2 font-weight-bold p-0">Program ID:</label>
                <p class="col-sm-2 p-0">00981</p>
              </div>
              <div class="row col-sm-12">
                <label class="col-sm-2 font-weight-bold" style="padding:0px 0px 0px 15px">Country:</label>
                <p class="col-sm-2" style="padding:0px 0px 0px 15px">Pakistan</p>

                <label class="col-sm-2 font-weight-bold p-0">City:</label>
                <p class="col-sm-2 p-0">Swat</p>
                <label class="col-sm-2 font-weight-bold p-0">Province:</label>
                <p class="col-sm-2 p-0">Khyber Pakhtunkhwa</p>
              </div>
              <div class="row col-sm-12">
                <label
                  class="col-sm-2 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >No. of Trainees (Participants)</label>
                <p class="col-sm-2" style="padding:0px 0px 0px 15px">
                  <router-link to="#" class="linked">156</router-link>
                </p>

                <label class="col-sm-2 font-weight-bold p-0">Male:</label>
                <p class="col-sm-2 p-0">11</p>
                <label class="col-sm-2 font-weight-bold p-0">Female:</label>
                <p class="col-sm-2 p-0">20</p>
              </div>
              <div class="row col-sm-12">
                <label
                  class="col-sm-2 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >Overall Satisfaction:</label>
                <p class="col-sm-2" style="padding:0px 0px 0px 15px">87%</p>
                <label class="col-sm-2 font-weight-bold p-0">Knowledge Gain:</label>
                <p class="col-sm-2 p-0">98%</p>

                <label class="col-sm-2 font-weight-bold p-0">Department / Organization:</label>
                <p class="col-sm-2 p-0">Police Department Swat</p>
              </div>
              <div class="row col-sm-12">
                <label class="col-sm-2 font-weight-bold" style="padding:0px 0px 0px 15px">Advisor:</label>
                <p class="col-sm-2" style="padding:0px 0px 0px 15px">Usman Khan</p>
                <label class="col-sm-2 font-weight-bold p-0">Program Officer:</label>
                <p class="col-sm-2 p-0">Saifullah Khan</p>

                <label class="col-sm-2 font-weight-bold p-0">Subprogram:</label>
                <p class="col-sm-2 p-0">Drugs & Crime</p>
              </div>

              <div class="row col-sm-12">
                <label class="col-sm-2 font-weight-bold" style="padding:0px 0px 0px 15px">Project:</label>
                <p class="col-sm-2" style="padding:0px 0px 0px 15px">Project Name</p>

                <label class="col-sm-2 font-weight-bold p-0">Training Type:</label>
                <p class="col-sm-2 p-0">Drugs & Crime</p>
              </div>
            </div>

            <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Funding Agency</h6>
              <div class="row col-sm-12">
                <label class="col-sm-3 font-weight-bold">UNICEF:</label>
                <div class="col-sm-3">
                  <img src="../../../assets/uniceflogo.png" alt width="20%" />
                </div>
                <label class="col-sm-3 font-weight-bold">UNDP:</label>
                <div class="col-sm-3">
                  <img src="../../../assets/undplogo.jpg" alt width="20%" />
                </div>
              </div>
            </div>

            <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Feedback</h6>
              <div class="row col-sm-12"></div>
              <div class="row col-sm-12">
                <label
                  class="col-sm-4 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >Level of satisfaction regarding methodology:</label>
                <p class="col-sm-2 p-0">Good</p>

                <label class="col-sm-3 font-weight-bold p-0">language:</label>
                <p class="col-sm-2" style="padding:0px 0px 0px 15px">Satisfactory</p>
              </div>

              <div class="row col-sm-12">
                <label
                  class="col-sm-4 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >Relevance to training:</label>
                <p class="col-sm-2 p-0">Training</p>

                <label class="col-sm-3 font-weight-bold p-0">Percentage Knowledge gap:</label>
                <p class="col-sm-2" style="padding:0px 0px 0px 15px">Highest</p>
              </div>

              <div class="row col-sm-12">
                <label class="col-sm-4 font-weight-bold" style="padding:0px 0px 0px 15px">Duration:</label>
                <p class="col-sm-2 p-0">Good</p>
                <label class="col-sm-3 font-weight-bold p-0">Future use of training knowledge:</label>
                <p class="col-sm-2" style="padding:0px 0px 0px 15px">Yes</p>
              </div>

              <div class="row col-sm-12">
                <label
                  class="col-sm-4 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >Use of practical exercises:</label>
                <p class="col-sm-2 p-0">Good</p>

                <label class="col-sm-3 font-weight-bold p-0">Frequency of skills:</label>
                <p class="col-sm-2" style="padding:0px 0px 0px 15px">Yes</p>
              </div>
              <div class="row col-sm-12"></div>
            </div>
            <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">No. of Trainers</h6>

              <div class="row col-sm-12 p-2">
                <div class="table-responsive">
                  <table class="table table-borderless">
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Contact No.</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>Dr Ali Mohammad</td>
                        <td>ali@gmail.com</td>
                        <td>0300 7628919</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Professor Ishtiaq</td>
                        <td>abc@gmail.com</td>
                        <td>0343 7892634</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Professor Khalil Khan</td>
                        <td>xyz@gmail.com</td>
                        <td>0312 8273842</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";

export default {
  data: () => ({
    isSidebar: false,
    checkBox1: false,
    basepath: process.env.VUE_APP_BASE_PATH,
    checkBox2: false,
    checkBox3: false,
    checkBox4: false,
    questions: [
      {
        question: "Are you satisfied with training",
        answer1: "Disagree",
        answer2: "Strongly Agree",
        answer3: "Agree",
        answer4: "Nuetral"
      },

      {
        question: "The objectives of the training were clearly defined. ",
        answer1: "Disagree",
        answer2: "Strongly Agree",
        answer3: "Agree",
        answer4: "Nuetral"
      },

      {
        question: "Participation & interaction were encouraged",
        answer1: "Disagree",
        answer2: "Strongly Agree",
        answer3: "Agree",
        answer4: "Nuetral"
      },

      {
        question: "The content was organzed & easy to follow",
        answer1: "Disagree",
        answer2: "Strongly Agree",
        answer3: "Agree",
        answer4: "Nuetral"
      }
    ],
    currentQ: 0
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    // Set the initial number of items
    // this.totalRows = this.items.length;
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  methods: {
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    formSubmitted() {
      alert("Form submitted!");
    },
    next: function() {
      if (this.currentQ + 1 < this.questions.length) {
        this.currentQ++;
      }
    },
    printInvoice: function() {
      window.print();
    }
  }
};
</script>
<style>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
li {
  list-style-type: none !important;
}

.f-500 {
  font-weight: 500;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #f9f9f9;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

.vs-popup--background {
  opacity: 0.3 !important;
}
.con-img-upload .img-upload {
  width: 150px !important;
}
.cont-bdr {
  display: none;
}
@media print {
  .print-btn {
    display: none;
  }
  .cont-bdr {
    display: block;
  }
  .heading {
    display: none;
  }
}
.cont-bdr {
  border-top: 1px solid #ebe9e9;
  border-right: 1px solid #ebe9e9;
}
.col-bdr-bottom {
  border-bottom: 0.5px solid #ebe9e9;
  border-left: 0.5px solid #ebe9e9;
}
</style>


